// ** React Imports
import {Fragment} from 'react'

// ** Dropdowns Imports
import IntlDropdown from './IntlDropdown'
import CartDropdown from './CartDropdown'
import UserDropdown from './UserDropdown'
import NavbarSearch from './NavbarSearch'
import NotificationDropdown from './NotificationDropdown'

// ** Custom Components
import NavbarBookmarks from './NavbarBookmarks'

// ** Third Party Components
import {Sun, Moon, Home} from 'react-feather'
import {NavItem, NavLink} from 'reactstrap'
import {useNavigate} from "react-router-dom";

const ThemeNavbar = props => {
    // ** Props
    const {skin, setSkin, setMenuVisibility} = props;
    const navigate = useNavigate();

    // ** Function to toggle Theme (Light/Dark)
    const ThemeToggler = () => {
        if (skin === 'dark') {
            return <Sun className='ficon' onClick={() => setSkin('light')}/>
        } else {
            return <Moon className='ficon' onClick={() => setSkin('dark')}/>
        }
    }

    return (
        <Fragment>
            <div className='bookmark-wrapper d-flex align-items-center'>
                <NavbarBookmarks setMenuVisibility={setMenuVisibility}/>
            </div>
            <ul className='nav navbar-nav align-items-center ml-auto'>
                <li>
                    <Home className="my-auto cursor-pointer" onClick={() => navigate("/")}/>
                </li>
                <UserDropdown/>

            </ul>
        </Fragment>
    )
}

export default ThemeNavbar
